import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";

export default function SimpleLoading({ status }) {
  return (
    <div className="progressSpinner">
      <Dialog
        visible={status}
        className="progressSpinner"
        style={{
          boxShadow: "none",
        }}
        closable={false}
        showHeader={false}
        blockScrol
      >
        <ProgressSpinner strokeWidth="6" fill="transparent" animationDuration=".5s" />
        <h3>Aguarde</h3>
      </Dialog>
    </div>
  );
}
